import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { DragDropContext, Droppable } from 'react-beautiful-dnd'

import { reorder } from '../../../functions'

// import ListGroup from './list-group'
import ListItem from './list-item'

class List extends Component {
  constructor(props) {
    super(props)

    this.state = {
      items: []
    }
  }

  componentWillMount() {
    const { items } = this.props

    this.setState({items})
  }

  componentWillUpdate(nextProps, nextState) {
    const { items } = nextProps

    if (items !== this.props.items) this.setState({items})
  }

  reorderList = (result) => {
    if (!result.destination) return null

    const items = reorder(
      this.state.items,
      result.source.index,
      result.destination.index
    )

    this.setState({items}, () => this.props.moveRiderItem({id: result.draggableId, position: result.destination.index+1}))
  }

  render() {
    const { stageElements } = this.props
    const { items } = this.state

    return (
      <div className="list">
        <DragDropContext onDragEnd={this.reorderList}>
          <Droppable droppableId="list" type="instrument">
            {(provided, snapshot) => (
              <div className="list--droppable"
                ref={provided.innerRef} >
                {
                  items.length > 0
                  ? items.map((item, index) => {
                      // if (item.id === undefined) return <Loading key={index} className="list-item list-item--loading" />

                      if (item.class.includes('monitor')) {
                        return (
                          <ListItem key={item.id || index}
                            dragDropType="instrument"
                            group={this.props.group}
                            item={item}
                            itemIndex={index}
                            itemGroups={this.props.itemGroups}
                            position={item.position}
                            required={item.required}
                            addRiderItem={this.props.addRiderItem}
                            removeRiderItem={this.props.removeRiderItem}
                            createRiderItem={this.props.createRiderItem}
                            editRiderItem={this.props.editRiderItem}
                            deleteRiderItem={this.props.deleteRiderItem}
                            stageElements={stageElements}
                            createStageElement={this.props.createStageElement}
                            getSearchResults={this.props.getSearchResults} />
                        )
                        /*return item.class === 'instrument-group'
                        ? <ListGroup key={item.id || index}
                            dragDropType={`instrument-group-${item.id}`}
                            group={this.props.group}
                            item={item}
                            itemIndex={index}
                            itemGroups={this.props.itemGroups}
                            addRiderItem={this.props.addRiderItem}
                            removeRiderItem={this.props.removeRiderItem}
                            createRiderItem={this.props.createRiderItem}
                            createRiderItems={this.props.createRiderItems}
                            editRiderItem={this.props.editRiderItem}
                            deleteRiderItem={this.props.deleteRiderItem}
                            stageElements={stageElements}
                            createStageElement={this.props.createStageElement}
                            getSearchResults={this.props.getSearchResults} />
                        : <ListItem key={item.id || index}
                            dragDropType="instrument"
                            group={this.props.group}
                            item={item}
                            itemIndex={index}
                            itemGroups={this.props.itemGroups}
                            position={item.position}
                            required={item.required}
                            addRiderItem={this.props.addRiderItem}
                            removeRiderItem={this.props.removeRiderItem}
                            createRiderItem={this.props.createRiderItem}
                            editRiderItem={this.props.editRiderItem}
                            deleteRiderItem={this.props.deleteRiderItem}
                            stageElements={stageElements}
                            createStageElement={this.props.createStageElement}
                            getSearchResults={this.props.getSearchResults} />*/
                      } else {
                        return null
                      }
                    })
                  : <p>Start by adding your <a onClick={() => {
                      this.props.addRiderItem({
                        class: "instrument",
                        position: items.length+1,
                        indexes: [
                          items.length
                        ]
                      })
                    }}>first instrument</a>.</p>
                }

                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>

        <button className="list--add-button button--link" onClick={() => {
          this.props.addRiderItem({
            class: "instrument",
            position: items.length+1,
            indexes: [
              items.length
            ]
          })
        }}>
          Insert instrument
        </button>
      </div>
    )
  }
}

List.propTypes = {
  group: PropTypes.string,
  items: PropTypes.array,
  itemGroups: PropTypes.array,
  addRiderItem: PropTypes.func,
  removeRiderItem: PropTypes.func,
  createRiderItem: PropTypes.func,
  createRiderItems: PropTypes.func,
  editRiderItem: PropTypes.func,
  moveRiderItem: PropTypes.func,
  deleteRiderItem: PropTypes.func,
  stageElements: PropTypes.object,
  createStageElement: PropTypes.func,
  getSearchResults: PropTypes.func
}

List.defaultProps = {
  group: '',
  items: [],
  itemGroups: [],
  addRiderItem: function() {},
  removeRiderItem: function() {},
  createRiderItem: function() {},
  createRiderItems: function() {},
  editRiderItem: function() {},
  moveRiderItem: function() {},
  deleteRiderItem: function() {},
  stageElements: {},
  createStageElement: function() {},
  getSearchResults: function() {}
}

export default List



// WEBPACK FOOTER //
// ./src/components/rider/rider-output/output-list/list.js